module.exports = __webpack_public_path__ + "img/HealthSciencesCampus_sign3-474x316.b48a5dbf.jpg";